'use strict';

module.exports = global;



/*****************
 ** WEBPACK FOOTER
 ** ./~/globalthis/implementation.js
 ** module id = 1013
 ** module chunks = 0
 **/